module.exports = __webpack_public_path__ + "static/media/m_eyeshape_almond_hazel.c210b108.png";